<template>
    <div class="card itembankCard">
        <div class="card-header" >
            <div class="row">
                <div class="col-9">
                <b>IMPORT NEW ITEM FROM THE ITEM COLLECTION</b> <br/>
                    <i>Search an item in the collection and drag&drop your choice on a page</i>
                </div>
                <div class="col-3" style="text-align: right;">
                    <button 
                    title="Close Item Library"  
                    type="button" 
                    class="btn btn-secondary"
                    @click="$emit('close')">
                        X
                    </button>
                </div>
            </div>
            
        </div>
        <div class="card-body">
            <div>
    <h3>Item Collection</h3>
    <input
      type="text"
      v-model="searchQuery"
      class="form-control mb-3"
      placeholder="Search items by label, text, rich text, or keywords..."
    />
    
    <!-- Affichage des items filtrés -->
    <div class="item-grid">
      <div
        class="item-card"
        v-for="item in filteredItems"
        :key="item.el_ID"
        :draggable="selectionMode === 'drag'"
        @dragstart="onDragStart(item)"
        @click="onItemClick(item)"
        :class="{ 'clickable': selectionMode === 'click' }"
      >
        <span :class="['badge', 'type-badge', getTypeBadgeClass(item.el_Type)]">
          {{ formatTypeName(item.el_Type) }}
        </span>
        <h4>{{ item.el_Label }}</h4>
        <p>{{ item.el_RichText }}</p>
        <p v-if="Array.isArray(item.el_keywords) && item.el_keywords.length">
          Keywords: {{ item.el_keywords.join(', ') }}
        </p>
      </div>
    </div>
  </div>

        </div>
    </div>

</template>

<script setup>
import { ref, onMounted,computed, watch } from "vue";
import api from "@/services/axios";



const props = defineProps({
  isVisible: Boolean,
  selectionMode: {
    type: String,
    default: 'drag' // 'drag' pour tests linéaires, 'click' pour tests conditionnels
  }
});

const emit = defineEmits(["close", "item-selected"]);

const items = ref([]);
const searchQuery = ref(""); 

// Simule le drag-and-drop
const onDragStart = (item) => {
  //event.dataTransfer.setData("application/json", JSON.stringify(item));
  event.dataTransfer.setData("text/plain", item._id);
};

// Gestion du clic pour sélection (mode click)
const onItemClick = (item) => {
  if (props.selectionMode === 'click') {
    console.log('📦 Item sélectionné (click mode):', item._id);
    emit('item-selected', item._id);
  }
};

// Filtrage des items
const filteredItems = computed(() => {
  if (!searchQuery.value.trim()) return items.value;

  const query = searchQuery.value.toLowerCase();

  return items.value.filter((item) => {
    return (
      item.el_Label.toLowerCase().includes(query) ||
      item.el_Text.toLowerCase().includes(query) ||
      item.el_RichText.toLowerCase().includes(query) ||
      item.el_keywords.some((keyword) => keyword.toLowerCase().includes(query))
    );
  });
});

const fetchItems = async () => {
  try {
    const response = await api.get(`/items/importer`, {
      params: { q: searchQuery.value }
    });
    items.value = response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des items :", error);
  }
};

watch(searchQuery, (newVal) => {
  if (newVal.length >= 2 || newVal.length === 0) {
    fetchItems();
  }
});

// Fonction pour obtenir la classe CSS du badge selon le type
const getTypeBadgeClass = (type) => {
  const typeClasses = {
    choice: 'badge-choice',
    choiceBlock: 'badge-choiceblock',
    textGaps: 'badge-textgaps',
    shortAnswer: 'badge-shortanswer',
    order: 'badge-order',
    match: 'badge-match',
    makingPairs: 'badge-makingpairs',
    hotSpot: 'badge-hotspot',
    message: 'badge-message',
    default: 'badge-default'
  };
  return typeClasses[type] || 'badge-default';
};

// Fonction pour formater le nom du type
const formatTypeName = (type) => {
  const typeNames = {
    choice: 'Choice',
    choiceBlock: 'Choice Block',
    textGaps: 'Text Gaps',
    shortAnswer: 'Short Answer',
    order: 'Order',
    match: 'Match',
    makingPairs: 'Making Pairs',
    hotSpot: 'Hot Spot',
    message: 'Message',
    default: 'Default'
  };
  return typeNames[type] || type || 'Unknown';
};

onMounted(fetchItems);
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.item-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.item-card {
  width: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: grab;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.item-card:active {
  cursor: grabbing;
}

.item-card:hover{
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  transition: all 0.2s ease;
}

.item-card.clickable {
  cursor: pointer;
}

.item-card.clickable:hover {
  background-color: #e3f2fd;
  border-color: #2196f3;
}

.item-card h4{
  font-size: 1rem;
  margin: 0;
  line-height: 1.3;
}

.item-card p {
  font-size: 0.85rem;
  margin: 0;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.badge-secondary{
    color:#c42020;
    border : 1px gainsboro solid;
}

.mainQ{
    font-size: 0.9rem;
}

.itembankCard {
  z-index: 1000;
  width: 80%;
  max-width: 900px;
  max-height: 80vh; /* Hauteur max visible */
  position: fixed;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto; /* Scroll vertical si contenu dépasse */
}

/* Type badges - couleurs distinctes pour chaque type */
.type-badge {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: inline-block;
  align-self: flex-start;
  margin-bottom: 4px;
}

/* Choice - Bleu */
.badge-choice {
  background-color: #E3F2FD;
  color: #1565C0;
  border: 1px solid #90CAF9;
}

/* Choice Block - Bleu foncé */
.badge-choiceblock {
  background-color: #C5CAE9;
  color: #283593;
  border: 1px solid #7986CB;
}

/* Text Gaps - Violet */
.badge-textgaps {
  background-color: #F3E5F5;
  color: #6A1B9A;
  border: 1px solid #CE93D8;
}

/* Short Answer - Vert */
.badge-shortanswer {
  background-color: #E8F5E9;
  color: #2E7D32;
  border: 1px solid #81C784;
}

/* Order - Orange */
.badge-order {
  background-color: #FFF3E0;
  color: #D84315;
  border: 1px solid #FFB74D;
}

/* Match - Teal */
.badge-match {
  background-color: #E0F2F1;
  color: #004D40;
  border: 1px solid #4DB6AC;
}

/* Making Pairs - Rose */
.badge-makingpairs {
  background-color: #FCE4EC;
  color: #880E4F;
  border: 1px solid #F06292;
}

/* Hot Spot - Rouge */
.badge-hotspot {
  background-color: #FFEBEE;
  color: #C62828;
  border: 1px solid #E57373;
}

/* Message - Jaune */
.badge-message {
  background-color: #FFF9C4;
  color: #F57F17;
  border: 1px solid #FFF176;
}

/* Default - Gris */
.badge-default {
  background-color: #F5F5F5;
  color: #616161;
  border: 1px solid #BDBDBD;
}

</style>